import { useEffect, useState } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

export default function TeamsAuthStart() {
  const [message, setMessage] = useState<string>('Initializing Microsoft Teams authentication...');

  useEffect(() => {
    let mounted = true;

    async function run() {
      try {
        await microsoftTeams.app.initialize();

        // Trigger an interactive token acquisition inside the popup to force consent if needed.
        microsoftTeams.authentication.getAuthToken({
          // Do NOT set silent here. We want the popup to be interactive.
          successCallback: (_token: string) => {
            if (!mounted) return;
            setMessage('Authentication succeeded. Closing popup...');
            // Notify the parent window that auth succeeded so it can retry silent token.
            microsoftTeams.authentication.notifySuccess('ok');
          },
          failureCallback: (reason: string) => {
            if (!mounted) return;
            setMessage(`Authentication failed: ${reason}`);
            // Notify failure and close the popup.
            microsoftTeams.authentication.notifyFailure(reason || 'Authentication failed');
          }
        });
      } catch (e: any) {
        const msg = e?.message || 'Failed to initialize Teams SDK';
        setMessage(msg);
        try {
          microsoftTeams.authentication.notifyFailure(msg);
        } catch {
          // ignore
        }
      }
    }

    run();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 520, textAlign: 'center' }}>
        <h3 style={{ marginBottom: 12 }}>Microsoft Teams Authentication</h3>
        <p style={{ color: '#666' }}>{message}</p>
      </div>
    </div>
  );
}
